<template>
  <div>
    <!-- 1、选择下单方式 -->
    <div class="bg-white pb-50" v-if="step < 8">
      <div
        :class="
          `setion1 ${
            step == 1 || step == 2 ? 'bg1' : step == 3 ? 'bg2' : step == 4 ? 'bg3' : step == 5 ? 'bg4' : 'bg5'
          } `
        "
      >
        <block v-if="step == 1">
          <div class="pointer custom1" @click="step = 2"></div>
          <div class="tip mt-20">
            <div class="point_t" style="top:-20px;left:52px"></div>
            <div class="title">请选择“下单类型”</div>
            <div>
              逐条下单：即普通下单模式，一次只可发布一个订单
            </div>
            <div>
              批量下单：若您的订单量过大，请选择批量下单
            </div>
          </div>
        </block>
        <block v-if="step == 2">
          <div class="pointer custom2" @click="step = 3"></div>
          <div class="tip" style="margin:20px 0 0 140px">
            <div class="point_t" style="top:-20px;left:52px"></div>
            <div class="title">地址解析</div>
            <div>
              将客户信息直接复制粘贴至地址智能识别框中
            </div>
            <div>
              系统将自动识别出客户姓名、手机号码以及地址
            </div>
          </div>
        </block>
        <block v-if="step == 3">
          <div class="pointer custom3" @click="step = 4"></div>
          <div class="tip" style="margin:20px 0 0 330px">
            <div class="point_t" style="top:-20px;left:130px"></div>
            <div class="title">请选择“订单类型”</div>
            <div>
              根据不同的服务类目，提供不同的服务类型
            </div>
          </div>
        </block>
        <block v-if="step == 4">
          <div class="pointer custom4" @click="step = 5"></div>
          <div class="tip" style="margin:20px 0 0 605px">
            <div class="point_t" style="top:-20px;left:130px"></div>
            <div class="title">请更改“安装要求”</div>
            <div>
              根据实际的情况，提供不同的安装要求
            </div>
          </div>
        </block>
        <block v-if="step == 5">
          <div class="pointer custom5" @click="step = 6"></div>
          <div class="tip" style="margin:20px 0 0 12px">
            <div class="point_t" style="top:-20px;left:170px"></div>
            <div class="title">请更改“付款方式”</div>
            <div>
              根据下单实际情况选择付款方式，后付款约定日期统结
            </div>
            <div>
              预付款需要线上账户有余额方可下单
            </div>
          </div>
        </block>
      </div>
      <div v-if="step > 5" :class="`setion2 ${step == 6 ? 'bg6' : 'bg7'}`">
        <block v-if="step == 6">
          <div class="pointer custom6" @click="clickRadio"></div>
          <div class="tip tip6">
            <div class="point_b" style="bottom:-20px;left:150px"></div>
            <div class="title">请选择“货物已到客户家”</div>
            <div>
              根据客户实际情况，请确保货物已到客户家，以免造成师傅跑空
            </div>
          </div>
        </block>
      </div>
      <div v-if="step > 6" class="setion3">
        <block v-if="step == 7">
          <div class="pointer custom7" @click="step = 8"></div>
          <div class="tip tip7">
            <div class="point_b" style="bottom:-20px;left:105px"></div>
            <div class="title">立即下单</div>
            <div>
              信息填写完成，请点击“提交”
            </div>
          </div>
        </block>
      </div>
    </div>
    <!-- 完成 -->
    <div class="bg-white" style="text-align:center;padding:200px 0" v-if="step == 8">
      <a-icon type="check-circle" style="font-size:100px;color:#00d66b" />
      <p style="font-size:16px;font-weight:700;margin:40px 0">下单教程已观看完毕，立即下单试试吧</p>
      <div>
        <a-button @click="step = 1" ghost size="large" type="primary" class="mr-40">
          再学一遍
        </a-button>
        <a-button @click="exit" size="large" type="primary">
          立即下单
        </a-button>
      </div>
    </div>
    <!-- 退出教程 -->
    <div v-if="step < 8" class="exit" @click="exit">
      <img src="@/assets/qyCourse/exit.png" alt="" style="width:120px" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1
    }
  },
  mounted() {},
  methods: {
    // 点击包裹信息，使页面滚动到最下边
    clickRadio() {
      this.step = 7
      this.$nextTick(() => {
        window.scrollTo(0, document.documentElement.clientHeight)
      })
    },
    exit() {
      this.step = 1
      this.$router.push({ name: 'qyCreateOrder' })
    }
  }
}
</script>
<style lang="less" scoped>
@red: #ff6a6a;
@blue: rgb(4, 241, 170);
.bg-white {
  background: #fff;
}
.setion1,
.setion2,
.setion3 {
  //   margin: 0 auto;
}
// 可点击区域
.pointer {
  cursor: pointer;
  &:hover {
    border: 1px solid @blue;
  }
}
// 提示框
.tip {
  background-color: @red;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  display: inline-block;
  position: relative;
  .point_t {
    border: 10px solid transparent;
    border-bottom-color: @red;
    position: absolute;
  }
  .point_b {
    border: 10px solid transparent;
    border-top-color: @red;
    position: absolute;
  }
  .title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}
.setion1 {
  width: 1120px;
  height: 560px;
  padding-top: 1px;
  .custom1 {
    width: 90px;
    height: 40px;
    margin: 18px 0 0 20px;
    border-radius: 4px;
  }
  .custom2 {
    width: 873px;
    height: 32px;
    margin: 84px 0 0 140px;
    border-radius: 4px;
  }
  .custom3 {
    width: 152px;
    height: 32px;
    margin: 247px 0 0 409px;
    border-radius: 4px;
  }
  .custom4 {
    width: 151px;
    height: 32px;
    margin: 249px 0 0 680px;
    border-radius: 4px;
  }
  .custom5 {
    width: 150px;
    height: 32px;
    margin: 304px 0 0 140px;
    border-radius: 4px;
  }
  &.bg1 {
    background-image: url(../../assets/qyCourse/1.png);
  }
  &.bg2 {
    background-image: url(../../assets/qyCourse/2.png);
  }
  &.bg3 {
    background-image: url(../../assets/qyCourse/3.png);
  }
  &.bg4 {
    background-image: url(../../assets/qyCourse/4.png);
  }
  &.bg5 {
    background-image: url(../../assets/qyCourse/5.png);
  }
}
.setion2 {
  width: 1120px;
  padding-top: 1px;
  position: relative;
  .tip6 {
    position: absolute;
    left: 140px;
    top: -100px;
  }
  .custom6 {
    width: 60px;
    height: 40px;
    margin: 10px 0 0 273px;
  }

  &.bg6 {
    height: 180px;
    background-image: url(../../assets/qyCourse/6.png);
  }
  &.bg7 {
    height: 60px;
    background-image: url(../../assets/qyCourse/7.png);
  }
}
.setion3 {
  width: 1120px;
  height: 498px;
  padding-top: 1px;
  background-image: url(../../assets/qyCourse/8.png);
  position: relative;
  .custom7 {
    width: 89px;
    height: 41px;
    margin: 452px 0 0 463px;
    border-radius: 4px;
  }
  .tip7 {
    position: absolute;
    left: 390px;
    bottom: 60px;
  }
}
.exit {
  position: fixed;
  right: 50px;
  top: 115px;
}
</style>
